<template>
    <div class="frmletolthetodokumentumok_formcont">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"></GrcDialog>
        <GrcDocDisplayer ref="DocDisplayer"></GrcDocDisplayer>

        <div class="frmletolthetodokumentumok_itemcont" v-show="InitDone">

            <div class="frmletolthetodokumentumok_col50">
                <div class="frmletolthetodokumentumok_item" v-for="(item, index) in ADOIG_COL1" :key="index"
                    @click="DisplayReport(item.EvParam)">
                    <i class="fal fa-file-pdf" style="margin-right:8px; font-size: 26px; vertical-align: text-bottom;"></i>{{item.Ev}}. évi 
                    Adóigazolás és egyenlegközlő
                </div>
            </div>

            <div class="frmletolthetodokumentumok_col50">
                <div class="frmletolthetodokumentumok_item" v-for="(item, index) in ADOIG_COL2" :key="index"
                    @click="DisplayReport(item.EvParam)">
                    <i class="fal fa-file-pdf" style="margin-right:8px; font-size: 26px; vertical-align: text-bottom;"></i>{{item.Ev}}. évi 
                    Adóigazolás és egyenlegközlő
                </div>
            </div>

        </div>




    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocDisplayer from '../GrcComponents/GrcDocDisplayer.vue'


export default {
  name: 'frmletolthetodokumentumok',
  components: {
      GrcDB,
      GrcDialog,
      GrcDocDisplayer,
  },
  props: {
  },
  data () {
      return {
          WSPREFIX: "frmLetolthetoDokumentumok_",

          InitDone:false,  

          ADOIG_COL1:[],
          ADOIG_COL2:[],


      }
  },
  model: {

  },  
  methods:{

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmLetolthetoDokumentumok", pCompName);
    },

    SetLang()
    {
        this.Init();
    },


    SetControlToFocus(pNextComp)
    {
      if (pNextComp == "") { return; }
      this.$refs[pNextComp].SetFocus();
    },

      async Init()
      {
        this.InitDone = false;

        var QP = { 
            sSESSIONID: "[APPSESSIONID]"
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        this.ADOIG_COL1 = Q.ADOIG_COL1;
        this.ADOIG_COL2 = Q.ADOIG_COL2;

        this.InitDone = true;

      },

    async DisplayReport(pEv)
    {
        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSESSIONID: "[APPSESSIONID]",
            iEv:pEv
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "GetReport", QP).then(res => { Q = res; });

        //console.log(Q);

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            gApp.HandleCommError(Q.APPERR[0].ERR);
            return;
        }

        this.$refs.GRCDB.HideLoading();

        var docb64 = Q.RESULT[0].DocData;
        var docfn = Q.RESULT[0].FajlNev;
        var docdfn = ""; // display fájlnév, ha üres, akkor az eredeti lesz, kiterjesztést ponttal együtt hozzáfűzi


        var docresult = this.$refs.DocDisplayer.ShowFile(docb64, docfn, docdfn);
        // grcmain_ShowFile(docb64, docfn, docdfn);

        if (docresult != "")
        {
            this.ShowResult(docresult, 200);
        }

    },

    async ShowResult(pText, pHeight)
    {
        var DialogResult = "";
        //await this.$refs.Dialog.Alert("Információ",pText).then(res => { DialogResult = res; });  
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = 20;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => { DialogResult = res; });               
    },

    async ShowError(pText)
    {
        var DialogResult = "";
        await this.$refs.Dialog.Alert("Hiba", pText).then(res => { DialogResult = res; });
        
    },



  },
  created()
  {

  },
  mounted()
  {
    //console.log("mount");
    this.SetLang();
    
  }

}


</script>


